module.exports = __webpack_public_path__ + "img/requests.9f76c065.svg";